<script>
  import Logo from "../images/Logo.svelte";
</script>

<footer class="text-center py-2">
  <Logo />
  <p class="small">Sistema de Búsquedas Integradas - 2024</p>
</footer>
